import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-registration-indetails',
  templateUrl: './registration-indetails.component.html',
  styleUrl: './registration-indetails.component.scss'
})
export class RegistrationIndetailsComponent {
  
  isLoading: boolean = false;
  type;
  start_date = '';
  end_date = '';
  rep_name = '';
  off_rep_name = '';
  issue_cat = '';
  issue_date = '';
  newindetails: boolean = false;
  indetail: boolean = false;
  brfly: boolean = false;
  verybrfly: boolean = false;
  datewise: boolean = false;
  officerep: boolean = false;
  inDetailsRegReport = [];
  inDetailsRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  inDetailsOffRegReportTotal = {
    total_advt: 0,
    advt_total: 0,
    net_amt: 0,
    gst: 0,
    total_amt: 0,
    rcvd_amt: 0,
    pndg_amt: 0,
  };
  tempdata = [];
  inDetailsRegReportsubTotalData = [];
  today;
  issue_name = '';
  issueDate;

  // ✅ FIX: Initialize as empty arrays instead of any
  inDetailsRegReport1: any[] = [];
  inDetailsRegReportrep: any[] = [];

  advtamt: number = 0;
  advtamti: number = 0;
  netadvtamt: number = 0;
  netadvtamti: number = 0;
  gstadvtamt: number = 0;
  totaladvtamt: number = 0;
  totalpendingadvtamt: number = 0;
  totalgst: number = 0;
  today1: string;
  issuenamewithdate: any;
  remaingtotal: number = 0;
  jamatotal: number = 0;
  inDetailsbriflydata: any;
  advtamtb: number = 0;
  netadvtamtb: number = 0;
  jamatotalb: number = 0;
  jamatotalc: number = 0;
  remaingtotalb: number = 0;
  inDetailsoff_repdata: any;
  inDetailsoff_repdatab: any;
  beforegst_amt: number;
  totalbeforegst_amt: number;
  totaldisc_total: number;
  totalbefore_gst: any;
  inDetailsRegReportbtoff: any;
  total_pending: any;
  inDetailsRegReportdatewise: any;
  showindetail: boolean = false;
  showindetaildatewise: boolean = false;
  showoffdatewise: boolean = false;
  showdatewisevrybrfly: boolean = false;
  showoffrepvrybrfly: boolean = false;
  showindetailoffrep: boolean = false;
  show: boolean;
  issuedatepp: any;
  newissuedatepp: any;
  value :any;

  // ✅ Selected items tracking
  selectedItems: any[] = [];

  constructor(
    private dialogref: MatDialogRef<RegistrationIndetailsComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    debugger
    this.type = this.data['type'];
    this.start_date = this.data['startDate'];
    this.end_date = this.data['endDate'];
    this.rep_name = this.data['rep_name'];
    this.off_rep_name = this.data['off_rep_name'];
    this.newissuedatepp = this.data['newissuedatepp'];
    this.issuedatepp = this.data['issuedatepp'];
    this.value = this.data['value'];


    this.issue_cat =
      this.data['issue_cat'] === undefined ? '' : this.data['issue_cat'];
    this.issue_date =
      this.data['issueDates'] === undefined ? '' : this.data['issueDates'];

    console.log(this.data);
    this.issueDate = this.issue_date + '';
    this.issue_name =
      this.issueDate.split(',')[0] == 'all'
        ? this.issueDate.split(',')[2]
        : this.issueDate.split(',')[1];
    this.issueDate =
      this.issueDate.split(',')[0] == 'all'
        ? this.issueDate.split(',')[1]
        : this.issueDate.split(',')[0];
    this.issueDate = new Date(
      `${this.issueDate.split('/')[1]}/${this.issueDate.split('/')[0]}/${this.issueDate.split('/')[2]
      }`
    );
    this.today = new Date();
    this.today1 = this.datePipe.transform(this.today, 'dd-MM-yyyy');

    if (this.type === 'In Detail') {
      this.indetail = true;
      if (this.off_rep_name !== '') {
        this.officerep = true;
      }
    } else if (this.type === 'Briefly') {
      this.brfly = true;
    } else if (this.type === 'Very Briefly') {
      this.verybrfly = true;
      if (this.off_rep_name !== '') {
        this.officerep = true;
      }
    } else if (this.type === 'Datewise') {
      this.datewise = true;
      this.verybrfly = true;
    }

    if (this.indetail && this.datewise && !this.officerep) {
      this.inDetailsDatewise();
    } else if (this.datewise && this.verybrfly) {
      this.datewiseVeryBriefly();
    } else if (this.indetail && this.officerep && !this.datewise) {
      this.inDetailsOffRep();
    } else if (this.brfly && this.officerep) {
      // this.inDetails();
    } else if (this.indetail && !this.datewise && !this.officerep) {
      this.inDetails();
    } else if (this.verybrfly && this.officerep) {
      this.offrepVeryBriefly();
    } else {
      this.getReportData();
    }
  }

  getRegReportData() {
    throw new Error('Method not implemented.');
  }

  exportexcel(fileName): void {
    let element = document.getElementById('print-section');
    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }
    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, fileName + '.xlsx');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  filteredinDetailsRegReport;

  addFilters() {
    if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name != '' &&
      this.off_rep_name != '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name == '' &&
      this.off_rep_name != '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name != '' &&
      this.off_rep_name == '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name != '' &&
      this.off_rep_name != '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name'])
        );
      });
    } else if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name == '' &&
      this.off_rep_name == '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name == '' &&
      this.off_rep_name != '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.off_rep_name.includes(a['off_rep_name'])
        );
      });
    } else if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name != '' &&
      this.off_rep_name == '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date &&
          this.rep_name.includes(a['rep_name'])
        );
      });
    } else if (
      this.start_date != '' &&
      this.end_date != '' &&
      this.rep_name == '' &&
      this.off_rep_name == '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['booking_date'] >= this.start_date &&
          a['booking_date'] <= this.end_date
        );
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name != '' &&
      this.off_rep_name != '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name == '' &&
      this.off_rep_name != '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.off_rep_name.includes(a['off_rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name != '' &&
      this.off_rep_name == '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.rep_name.includes(a['rep_name']) &&
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name != '' &&
      this.off_rep_name != '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          this.rep_name.includes(a['rep_name']) &&
          this.off_rep_name.includes(a['off_rep_name'])
        );
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name == '' &&
      this.off_rep_name == '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name == '' &&
      this.off_rep_name != '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.off_rep_name.includes(a['off_rep_name']);
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name != '' &&
      this.off_rep_name == '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return this.rep_name.includes(a['rep_name']);
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name == '' &&
      this.off_rep_name == '' &&
      this.issue_cat != '' &&
      this.issue_date != ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport.filter((a) => {
        return (
          a['issuename'] === this.issue_cat &&
          this.issue_date.includes(a['issue_date'])
        );
      });
    } else if (
      this.start_date == '' &&
      this.end_date == '' &&
      this.rep_name == '' &&
      this.off_rep_name == '' &&
      this.issue_cat == '' &&
      this.issue_date == ''
    ) {
      this.filteredinDetailsRegReport = this.inDetailsRegReport;
    }

    console.log(this.filteredinDetailsRegReport);
    this.filtersCalculateData();
  }

  filtersCalculateData() {
    this.inDetailsRegReportTotal = {
      total_advt: 0,
      net_amt: 0,
      advt_total: 0,
      gst: 0,
      total_amt: 0,
      rcvd_amt: 0,
      pndg_amt: 0,
    };

    this.inDetailsRegReportTotal.total_advt =
      this.filteredinDetailsRegReport.length;

    for (let index = 0; index < this.filteredinDetailsRegReport.length; index++) {
      const row = this.filteredinDetailsRegReport[index];
      this.inDetailsRegReportTotal.net_amt += parseFloat(row['total_amount'] || 0);
      this.inDetailsRegReportTotal.advt_total += parseFloat(row['advt_amt'] || 0);
      this.inDetailsRegReportTotal.gst += parseFloat(row['sgst'] || 0);
      this.inDetailsRegReportTotal.gst += parseFloat(row['cgst'] || 0);
      this.inDetailsRegReportTotal.total_amt += parseFloat(row['amount'] || 0);
      this.inDetailsRegReportTotal.pndg_amt += parseFloat(row['part_pymt_remaning_amt'] || 0);
    }
  }

  getReportData() {
    const req1: any = {
      start_date: this.start_date,
      end_date: this.end_date,
      rep_name: this.rep_name,
      off_rep_name: this.off_rep_name,
      issuename: this.issue_cat,
      issue_date: this.issue_date,
      value: this.value,
    };

    // ✅ Main InDetails — isSelected comes directly from PHP LEFT JOIN
    this.service.getRegReportInDetails1(req1).subscribe((data) => {
      this.inDetailsRegReport = data;

      // ✅ FIX: map isSelected from PHP response directly
      this.inDetailsRegReport1 = data.map((item: any) => ({
        ...item,
        isSelected: item.isSelected === true || item.saved_by != null,
      }));

      // ✅ FIX: get issuenamewithdate from first item safely
      this.issuenamewithdate =
        this.inDetailsRegReport1.length > 0
          ? this.inDetailsRegReport1[0]?.issue_date
          : '';

      console.log(this.inDetailsRegReport1, 'reg report');

      this.advtamti = 0;
      this.netadvtamti = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotal = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalc = 0;
      this.totalbeforegst_amt = 0;
      this.totaldisc_total = 0;

      for (let data1 of this.inDetailsRegReport1) {
        this.advtamti += parseFloat(data1.advt_amt) || 0;
        this.netadvtamti += parseFloat(data1.amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotal += parseFloat(data1.remaingamt) || 0;
        this.totalbeforegst_amt += parseFloat(data1.total_amount) || 0;
        this.jamatotalc += parseFloat(data1.pymt_rcv_amt) || 0;
        this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
        data1.totalgst =
          parseFloat(data1.sgst) +
          parseFloat(data1.cgst) +
          parseFloat(data1.igst);
        this.totalgst += parseFloat(data1.totalgst);
      }

      // ✅ Populate selectedItems from already saved records
      this.selectedItems = this.inDetailsRegReport1.filter(
        (item: any) => item.isSelected
      );

      console.log(
        'Pre-checked items:',
        this.selectedItems.length,
        this.totalbeforegst_amt,
        'before gst'
      );
    });

    // off indetails
    this.service.getRegReportInDetailsoff(req1).subscribe((data) => {
      this.inDetailsRegReportbtoff = data;

      // ✅ FIX: get issuenamewithdate from first item safely
      this.issuenamewithdate =
        data.length > 0 ? data[0]?.issue_date : '';

      console.log(data, 'reg report off');

      this.advtamt = 0;
      this.netadvtamt = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotal = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotal = 0;
      this.totalbeforegst_amt = 0;
      this.totaldisc_total = 0;

      for (let data1 of data) {
        this.advtamt += parseFloat(data1.advt_amt) || 0;
        this.netadvtamt += parseFloat(data1.total_amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotal += parseFloat(data1.remaingamt) || 0;
        this.totalbeforegst_amt += parseFloat(data1.beforegst_amt) || 0;
        this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
        this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
        data1.totalgst =
          parseFloat(data1.sgst) +
          parseFloat(data1.cgst) +
          parseFloat(data1.igst);
        this.totalgst += parseFloat(data1.totalgst) || 0;
      }
    });

    this.service.getRegReportBriefly(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsbriflydata = data;

      this.advtamtb = 0;
      this.netadvtamtb = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotalb = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalb = 0;

      for (let data1 of this.inDetailsbriflydata) {
        this.advtamtb += parseFloat(data1.advt_amt) || 0;
        this.netadvtamtb += parseFloat(data1.total_amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
        this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
        this.totalgst += parseFloat(data1.gst);
      }
    });

    this.service.getRegReportOff_rep(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsoff_repdata = data;

      this.advtamtb = 0;
      this.netadvtamtb = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotalb = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalb = 0;

      for (let data1 of this.inDetailsoff_repdata) {
        this.advtamtb += parseFloat(data1.advt_amt) || 0;
        this.netadvtamtb += parseFloat(data1.amount) || 0;
        this.totaladvtamt += parseFloat(data1.amount) || 0;
        this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
        this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
        this.totalgst += parseFloat(data1.gst);
        for (let data2 of data1.advt_data) {
          this.jamatotalb += parseFloat(data2.rcv_amt) || 0;
        }
      }
    });

    this.service.getRegReportOff_repb(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsoff_repdatab = data;

      this.advtamtb = 0;
      this.netadvtamtb = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotalb = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotalb = 0;

      // ✅ FIX: guard before looping inDetailsbriflydata
      if (this.inDetailsbriflydata && this.inDetailsbriflydata.length > 0) {
        for (let data1 of this.inDetailsbriflydata) {
          this.advtamtb += parseFloat(data1.advt_amt) || 0;
          this.netadvtamtb += parseFloat(data1.amount) || 0;
          this.totaladvtamt += parseFloat(data1.amount) || 0;
          this.remaingtotalb += parseFloat(data1.remaingamt) || 0;
          this.jamatotalb += parseFloat(data1.pymt_rcv_amt) || 0;
          this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
          this.totalgst += parseFloat(data1.gst);
        }
      }
    });

    this.service.getRegReportInDetailsrep(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsRegReportrep = data; // ✅ array initialized above

      // ✅ FIX: get from first item safely
      this.issuenamewithdate =
        this.inDetailsRegReport1.length > 0
          ? this.inDetailsRegReport1[0]?.issue_date
          : '';

      this.advtamt = 0;
      this.netadvtamt = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotal = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotal = 0;
      this.totaldisc_total = 0;
      this.totalbefore_gst = 0;
      this.total_pending = 0;

      // ✅ FIX: guard before looping
      if (this.inDetailsRegReportrep && this.inDetailsRegReportrep.length > 0) {
        for (let data2 of this.inDetailsRegReportrep) {
          for (let data1 of data2.advt_data) {
            this.advtamt += parseFloat(data1.advt_amt) || 0;
            this.netadvtamt += parseFloat(data1.total_amount) || 0;
            this.totaladvtamt += parseFloat(data1.amount) || 0;
            this.remaingtotal += parseFloat(data1.remaingamt) || 0;
            this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
            this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
            this.totalbefore_gst += parseFloat(data1.beforegst_amt) || 0;
            this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
            data1.totalgst =
              parseFloat(data1.sgst) +
              parseFloat(data1.cgst) +
              parseFloat(data1.igst);
            this.totalgst += parseFloat(data1.totalgst) || 0;
            this.total_pending += parseFloat(data1.remaining_amt) || 0;
          }
        }
      }

      console.log(this.total_pending, 'total_pending');
    });

    this.service.getRegReportInDetailsdatewise(req1).subscribe((data) => {
      this.inDetailsRegReport = data;
      this.inDetailsRegReportdatewise = data;

      // ✅ FIX: get from first item safely
      this.issuenamewithdate =
        this.inDetailsRegReport1.length > 0
          ? this.inDetailsRegReport1[0]?.issue_date
          : '';

      this.advtamt = 0;
      this.netadvtamt = 0;
      this.gstadvtamt = 0;
      this.totaladvtamt = 0;
      this.totalgst = 0;
      this.remaingtotal = 0;
      this.totalpendingadvtamt = 0;
      this.jamatotal = 0;
      this.totaldisc_total = 0;
      this.totalbefore_gst = 0;
      this.total_pending = 0;

      // ✅ FIX: guard before looping inDetailsRegReportrep
      if (this.inDetailsRegReportrep && this.inDetailsRegReportrep.length > 0) {
        for (let data2 of this.inDetailsRegReportrep) {
          for (let data1 of data2.advt_data) {
            this.advtamt += parseFloat(data1.advt_amt) || 0;
            this.netadvtamt += parseFloat(data1.total_amount) || 0;
            this.totaladvtamt += parseFloat(data1.amount) || 0;
            this.remaingtotal += parseFloat(data1.remaingamt) || 0;
            this.jamatotal += parseFloat(data1.pymt_rcv_amt) || 0;
            this.totaldisc_total += parseFloat(data1.disc_amt) || 0;
            this.totalbefore_gst += parseFloat(data1.beforegst_amt) || 0;
            this.totalpendingadvtamt += parseFloat(data1.part_pymt_remaning_amt) || 0;
            data1.totalgst =
              parseFloat(data1.sgst) +
              parseFloat(data1.cgst) +
              parseFloat(data1.igst);
            this.totalgst += parseFloat(data1.totalgst) || 0;
            this.total_pending += parseFloat(data1.remaining_amt) || 0;
          }
        }
      }

      console.log(this.inDetailsRegReportdatewise, 'inDetailsRegReportdatewise');

      this.addFilters();
      this.getReportDatewise();
    });
  }

  getReportDatewise() {
    if (this.filteredinDetailsRegReport && this.filteredinDetailsRegReport.length > 0) {
      this.tempdata = this.uniqueId(
        this.filteredinDetailsRegReport,
        (a) => a.booking_date
      );
      for (let index = 0; index < this.tempdata.length; index++) {
        let arr = this.filteredinDetailsRegReport.filter((a) => {
          return a.booking_date == this.tempdata[index]['booking_date'];
        });

        let inDetailsRegReportsubTotal = {
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseFloat(arr[index]['total_amount']);
          inDetailsRegReportsubTotal.advt_total += parseFloat(arr[index]['advt_amt']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(arr[index]['amount']);
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(arr[index]['part_pymt_amt']);
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(arr[index]['part_pymt_remaning_amt']);
        }
        arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(arr);
        console.log(this.inDetailsRegReportsubTotalData, 'abc');
      }
    }
  }

  inDetails() {
    console.log('inDetails');
    this.getReportData();
  }

  inDetailsDatewise() {
    console.log('inDetailsDatewise');
    this.getReportData();
    this.getReportDatewise();
  }

  offrepVeryBriefly() {
    console.log('offrepVeryBriefly');
    this.getReportData();
    setTimeout(() => {
      this.getReportOffRepVeryBriefly();
    }, 200);
  }

  datewiseVeryBriefly() {
    this.getReportData();
    setTimeout(() => {
      this.getReportDatewiseVeryBriefly();
    }, 200);
  }

  inDetailsOffRep() {
    this.getReportData();
    setTimeout(() => {
      this.getReportInDetailOffRep();
    }, 200);
  }

  uniqueId(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  toInt(no) {
    return parseFloat(no);
  }

  getReportDatewiseVeryBriefly() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.uniqueId(
        this.inDetailsRegReport,
        (a) => a.booking_date
      );
      for (let index = 0; index < this.tempdata.length; index++) {
        let arr = this.inDetailsRegReport.filter((a) => {
          return a.booking_date == this.tempdata[index]['booking_date'];
        });

        let inDetailsRegReportsubTotal = {
          date: '',
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        inDetailsRegReportsubTotal.date = arr[0]['booking_date'];
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseFloat(arr[index]['total_amount']);
          inDetailsRegReportsubTotal.advt_total += parseFloat(arr[index]['advt_amt']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(arr[index]['amount']);
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(arr[index]['part_pymt_amt']);
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(arr[index]['part_pymt_remaning_amt']);
        }
        this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
      }
    }
  }

  repData = [];

  getReportInDetailOffRep() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.inDetailsRegReport.filter((a) => {
        return this.off_rep_name.includes(a.off_rep_name);
      });
      this.calculateTotal(this.tempdata);

      let data = this.uniqueId(this.tempdata, (a) => a.rep_name);

      for (let index = 0; index < Object.keys(data).length; index++) {
        let arr = this.tempdata.filter((a) => {
          return a.rep_name == data[index]['rep_name'];
        });

        let inDetailsRegReportsubTotal = {
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.net_amt += parseFloat(arr[index]['total_amount']);
          inDetailsRegReportsubTotal.advt_total += parseFloat(arr[index]['advt_amt']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(arr[index]['amount']);
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(arr[index]['part_pymt_amt']);
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(arr[index]['part_pymt_remaning_amt']);
        }
        arr.push(inDetailsRegReportsubTotal);
        this.inDetailsRegReportsubTotalData.push(arr);
      }
    }
  }

  calculateTotal(data) {
    this.inDetailsOffRegReportTotal.total_advt = data.length;
    for (let index = 0; index < data.length; index++) {
      this.inDetailsOffRegReportTotal.net_amt += parseFloat(data[index]['total_amount']);
      this.inDetailsOffRegReportTotal.advt_total += parseFloat(data[index]['advt_amt']);
      this.inDetailsOffRegReportTotal.gst += parseFloat(data[index]['sgst']);
      this.inDetailsOffRegReportTotal.gst += parseFloat(data[index]['cgst']);
      this.inDetailsOffRegReportTotal.total_amt += parseFloat(data[index]['amount']);
      this.inDetailsOffRegReportTotal.rcvd_amt += parseFloat(data[index]['part_pymt_amt']);
      this.inDetailsOffRegReportTotal.pndg_amt += parseFloat(data[index]['part_pymt_remaning_amt']);
    }
  }

  getReportOffRepVeryBriefly() {
    if (this.inDetailsRegReport.length > 0) {
      this.tempdata = this.inDetailsRegReport.filter((a) => {
        return this.off_rep_name.includes(a.off_rep_name);
      });
      this.calculateTotal(this.tempdata);

      let data = this.uniqueId(this.tempdata, (a) => a.rep_name);

      for (let index = 0; index < Object.keys(data).length; index++) {
        let arr = this.tempdata.filter((a) => {
          return a.rep_name == data[index]['rep_name'];
        });

        let inDetailsRegReportsubTotal = {
          off_rep_name: '',
          rep_name: '',
          total_advt: 0,
          advt_total: 0,
          net_amt: 0,
          gst: 0,
          total_amt: 0,
          rcvd_amt: 0,
          pndg_amt: 0,
        };

        inDetailsRegReportsubTotal.total_advt = arr.length;
        for (let index = 0; index < arr.length; index++) {
          inDetailsRegReportsubTotal.off_rep_name = arr[index]['off_rep_name'];
          inDetailsRegReportsubTotal.rep_name = arr[index]['rep_name'];
          inDetailsRegReportsubTotal.net_amt += parseFloat(arr[index]['total_amount']);
          inDetailsRegReportsubTotal.advt_total += parseFloat(arr[index]['advt_amt']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['sgst']);
          inDetailsRegReportsubTotal.gst += parseFloat(arr[index]['cgst']);
          inDetailsRegReportsubTotal.total_amt += parseFloat(arr[index]['amount']);
          inDetailsRegReportsubTotal.rcvd_amt += parseFloat(arr[index]['part_pymt_amt']);
          inDetailsRegReportsubTotal.pndg_amt += parseFloat(arr[index]['part_pymt_remaning_amt']);
        }
        this.inDetailsRegReportsubTotalData.push(inDetailsRegReportsubTotal);
      }
    }
  }

  printPageA3Portrait() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
      console.error('Print section not found!');
      return;
    }

    const printContent = printSection.innerHTML;
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1000;
    const leftPosition = screenWidth - windowWidth - 50;

    const printWindow = window.open(
      '',
      '',
      `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`
    );

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report</title>
            <style>
              @media print {
                @page { size: A3 landscape; margin: 5mm; }
                body { font-family: Arial, sans-serif; margin: 0; padding: 0; font-size: 14px !important; }
                .print-section { width: 100%; margin: 0 auto; padding: 0; }
                table { width: auto !important; border-collapse: collapse; table-layout: auto; page-break-inside: auto; border: 1px solid black !important; }
                tr { page-break-inside: avoid; page-break-after: auto; }
                th, td { padding: 4px 4px !important; border: 1px solid black !important; font-size: 14px; line-height: 1.2; white-space: nowrap; }
                th { background-color: #f2f2f2; font-weight: bold; }
                tr { border-bottom: 1px solid black !important; }
                .noPrint { display: none !important; }
                .footer-line { position: fixed; bottom: 0; left: 0; width: 100%; height: 1px; background-color: black; }
                thead { display: table-header-group; border: 1px solid black !important; }
                tfoot { display: table-footer-group; border: 1px solid black !important; }
                table, th, td { border-style: solid !important; border-width: 1px !important; border-color: black !important; }
                thead tr { display: table-row !important; }
              }
            </style>
          </head>
          <body>
            <div class="print-section">
              ${printContent}
              <div class="footer-line"></div>
            </div>
            <script>
              window.onload = function () {
                setTimeout(() => { window.print(); setTimeout(() => { window.close(); }, 500); }, 200);
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } else {
      console.error('Failed to open print window.');
    }
  }

  // ✅ Select All / Deselect All
  selectAll(event: any): void {
    const checked = event.target.checked;
    if (this.inDetailsRegReport1 && this.inDetailsRegReport1.length > 0) {
      this.inDetailsRegReport1.forEach((item: any) => {
        item.isSelected = checked;
      });
      this.selectedItems = checked ? [...this.inDetailsRegReport1] : [];
    }
    console.log('Selected Items:', this.selectedItems.length);
  }

  // ✅ Individual checkbox change
  onCheckboxChange(item: any): void {
    if (!item) return;
    if (item.isSelected) {
      if (!this.selectedItems.find((s) => s.booking_no === item.booking_no)) {
        this.selectedItems.push(item);
      }
    } else {
      this.selectedItems = this.selectedItems.filter(
        (s) => s.booking_no !== item.booking_no
      );
    }
    console.log('Selected Items:', this.selectedItems.length);
  }

  saveSelected(): void {
    if (this.selectedItems.length === 0) {
      alert('No items selected!');
      return;
    }

    // ✅ Only send items that are NOT already saved in DB
    const newItemsOnly = this.selectedItems.filter(
      (item: any) => !item.saved_by || item.saved_by === null || item.saved_by === ''
    );

    if (newItemsOnly.length === 0) {
      alert('All selected items are already saved!');
      return;
    }

    const payload = {
      selected_items: newItemsOnly.map((item) => ({
        booking_no: item.booking_no,
        advt_name: item.advt_name,
        advt_amt: item.advt_amt,
        amount: item.amount,
        issue_date: item.issue_date,
      })),
      saved_by: 'admin', // replace with logged-in user
    };

    this.service.saveSelectedAdvt(payload).subscribe({
      next: (res) => {
        alert('Saved successfully! Total: ' + res.total_saved);

        // ✅ Mark newly saved items as saved_by so they won't save again
        newItemsOnly.forEach((item: any) => {
          item.saved_by = 'admin';
        });

        console.log(res);
      },
      error: (err) => {
        alert('Failed to save!');
        console.error(err);
      },
    });
  }
}